import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { FileUploader }         from 'ng2-file-upload';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class SedeService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'sede'].join('/');
  }

  public save(model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    model.imagen = 'logo-inger.png';

    return new Observable(observer => {
      super.save(model)
        .subscribe(
          data => {
            if(file.queue.length > 0) {
              file.authToken      = this.auth.getToken();
              file.options.url    = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url   = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if(file.queue[0]._xhr.readyState == 4) {
                  data.imagen = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }               
            } else {
              observer.next(data);
            }
          },
          error => console.log(error)
        )
    });
  }
 
  public update(id, model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    delete model.imagen;

    return new Observable(observer => {
      super.update(id, model)
        .subscribe(
          data => {
            if(file.queue.length > 0) {
              file.authToken      = this.auth.getToken();
              file.options.url    = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url   = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if(file.queue[0]._xhr.readyState == 4) {
                  data.imagen = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }               
            } else {
              observer.next(data);
            }
          },
          error => console.log(error)
        )
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sede/sede.service.ts